import { useCallback, useState } from "react";
import { Button } from "antd";
import { ShopOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { startGetTalleresGeneralSeguros } from "../../../../../../../context/actions/crearServiciosV2Actions";

export const TalleresButton = ({ talleres, onTalleresLoad, onToggle, activos }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (talleres) {
      onToggle();
      return;
    }
    setLoading(true);
    const result = await dispatch(startGetTalleresGeneralSeguros());
    setLoading(false);
    if (result.success) {
      onTalleresLoad(result.data);
    }
  }, [talleres, dispatch, onTalleresLoad, onToggle]);

  return (
    <Button
      type={activos ? "primary" : "default"}
      icon={<ShopOutlined />}
      block
      size="large"
      loading={loading}
      onClick={handleClick}
    >
      {activos ? "Ocultar Talleres" : "Talleres General de Seguros"}
    </Button>
  );
};
